import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';
import {
  GTM,
  GoogleAnalyticsModel,
  GoogleTagManagerModel,
} from '../../models/gtm.models';
import { AuthService } from '../auth/auth.service';

declare const dataLayer: GTM[];

@Injectable()
export class GtmService {
  private cookies: any = {
    _ga: '',
  };

  private idUsuario: string;
  private status: string;

  constructor(
    private http: CommonService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.getCookies();
  }

  private getCookies() {
    const cookiesSplit = document.cookie.split('; ');
    for (let i = 0; i < cookiesSplit.length; i++) {
      const cur = cookiesSplit[i].split('=');
      this.cookies[cur[0]] = cur[1];
    }
  }

  public sendVarGTM(event: GoogleAnalyticsModel, changePage = true) {
    this.authService.getStatus().subscribe((data) => (this.status = data));
    event.hitTimestamp = event.hitTimestamp ? event.hitTimestamp : new Date().getTime();
    event.clientId = event.clientId ? event.clientId : this.cookies._ga;
    if (this.idUsuario || sessionStorage.getItem('idGTM')) {
      event.userId = this.idUsuario || sessionStorage.getItem('idGTM');
    }
    if (this.status) {
      event.Estado_Hipoteca = this.getEstadoHipoteca(String(this.status));
    }

    dataLayer.push(event);
    if (changePage) {
      this.updateDataLayer();
    }
  }

  public sendEventGTM(event: GoogleTagManagerModel) {
    dataLayer.push(event);
  }

  /** Este método hace un pusg para evitar que los eventos y las variables se envien con demora. */
  private updateDataLayer() {
    dataLayer.push({
      event: 'pageView',
      eAction: this.router.url,
    });
  }

  public getUserIdGTM(email: string): Observable<{ idClient: string }> {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/clientId`;
    return this.http
      .postVerb(url, {
        email,
        origin: 'MTG_Mortgage',
      })
      .pipe(
        tap((resp) => {
          this.idUsuario = resp.idClient;
          sessionStorage.setItem('idGTM', resp.idClient);
        }),
      );
  }

  getEstadoHipoteca(status) {
    switch (status) {
      case '1':
        return 'saveData';
      case '4':
        return 'simulation_done';
      case '4.1':
        return 'simulation_done_subtype_1';
      case '4.2':
        return 'simulation_done_subtype_2';
      case '4.3':
        return 'waitingAceptedSecondHolder';
      case '4.4':
        return 'modifyDataSecondHolder';
      case '4.5':
        return 'refuseSecondHolder';
      case '5':
        return 'attachDocumentation';
      case '5.5':
        return 'finalizeAttachDocumentation';
      case '6':
        return 'validatingDocumentation';
      case '7':
        return 'appraisal';
      case '8':
        return 'appraisal_done';
      case '9':
        return 'signature';
      case '10':
        return 'inscription';
    }
  }
}
